import {
  AccountStatus,
  IAccount,
  IActivity,
  INewUser,
  IRedactedMember,
  IRedactedUser
} from "@wingspanhq/users/dist/lib/interfaces";
import orderBy from "lodash/orderBy";
import { COUNTRY_OPTIONS } from "../../constants/user";
import { selectorAccountVerificationPending } from "../../shared/selectors/selectorAccountVerificationPending";

export const getPossiblePaymentsAccounts = (accounts: IAccount[]) =>
  orderBy(
    accounts.filter(
      account =>
        (account.canBeUsedFor?.payments ||
          selectorAccountVerificationPending(account)) &&
        account.status !== AccountStatus.Inactive
    ),
    "name",
    "asc"
  );

export const get1099SetupProgress = (activity?: IActivity) => {
  return (
    activity?.flows.nec1099Setup || {
      version: 1,
      currentStep: 0,
      totalSteps: 4,
      complete: false
    }
  );
};

export const getUserLegalName = (
  user: INewUser | IRedactedUser,
  firstName?: string,
  lastName?: string
) =>
  `${firstName || user.profile?.firstName || ""} ${
    lastName || user.profile?.lastName || ""
  }`.trim();

export const getUserName = (user: INewUser) =>
  user.profile.preferredName || getUserLegalName(user);

export const getRedactedUserName = (user: IRedactedUser) =>
  `${user?.profile?.firstName || ""} ${user?.profile?.lastName || ""} ${
    (user?.profile as any)?.preferredName
      ? `(${(user?.profile as any)?.preferredName})`
      : ""
  }`.trim();

export const getRedactedMemberName = (member: IRedactedMember) =>
  getRedactedUserName(member.user) ||
  member.profile?.company?.name ||
  (member.user.email as string);

export const getCountryName = (alpha2Code: string) =>
  COUNTRY_OPTIONS.find(country => country.value === alpha2Code)?.label;
